import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { CardProps, setLengthMin, setLengthMinUndefined, StateProps } from "../../store";
import * as S from "./styles";

const TeamNumberMinInput = ({ id }: Pick<CardProps, "id">) => {
  const currentCard = useSelector((state: StateProps) => state.cards.find((card) => card.id === id));

  const dispatch = useDispatch();

  const requiredCardIds = useSelector((state: StateProps) => state.required as string[]);

  const needToCompleteRequired = requiredCardIds.includes(id);

  const setLength = (lengthMin: string) => {
    console.log('setLength', lengthMin)
    if(lengthMin === "") {
      dispatch(setLengthMinUndefined({ cardId: id, lengthMin }));
    }else {
      dispatch(setLengthMin({ cardId: id, lengthMin }));
    }
  }

  const getLength = () => {
    const lengthMin = currentCard?.lengthMin;

    if(lengthMin === undefined || lengthMin === null) {
      return "";
    }

    if (lengthMin || lengthMin === 0) {
      return lengthMin;
    }
    return "";
  }


  return (
    <S.LengthMinDiv>최대 <S.LengthMinInput
      id="standard-basic"
      type="number"
      variant="standard"
      alert={needToCompleteRequired}
      value={getLength()}
      onChange={(e) => setLength(e.target.value)}
    />명</S.LengthMinDiv>
  );
};

export default TeamNumberMinInput;
